import { render, staticRenderFns } from "./DappDetailedChartFilter.vue?vue&type=template&id=501972e9&scoped=true"
import script from "./DappDetailedChartFilter.vue?vue&type=script&lang=ts"
export * from "./DappDetailedChartFilter.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedChartFilter.vue?vue&type=style&index=0&id=501972e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501972e9",
  null
  
)

export default component.exports